import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

interface MatchDetailsProps {
  details: Record<string, number>;
  className?: string;
}

const fieldLabels: Record<string, string> = {
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  website: 'Website',
  location: 'Location',
};

export function MatchDetails({ details, className }: MatchDetailsProps) {
  const entries = Object.entries(details).filter(([_, score]) => score > 0);
  
  if (entries.length === 0) return null;

  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium text-muted-foreground">Match Breakdown</p>
      {entries.map(([field, score]) => (
        <div key={field} className="flex items-center gap-2">
          <span className="text-xs w-16 text-muted-foreground">
            {fieldLabels[field] || field}
          </span>
          <Progress 
            value={score} 
            className="h-1.5 flex-1"
          />
          <span className="text-xs w-8 text-right font-medium">
            {score}%
          </span>
        </div>
      ))}
    </div>
  );
}
